import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { FlowClient } from '@@api';

import { FlowMetadataModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiFlowMetadata(): UseQueryResult<FlowMetadataModel, Error> {
	const client = useApiClient(FlowClient);
	const metadata = useQuery({
		queryKey: ['flowMetadata'],
		queryFn: () => client.getMetadata(),
	});
	return metadata;
}
